export default "__VITE_ASSET__FeTpjIJL__"